function FindOutMore () {
  window.location = 'https://www.bookinglive.com/connect/';
  return null;
}

export default FindOutMore;
